import { resolveComponent as _resolveComponent, createVNode as _createVNode, vModelText as _vModelText, createElementVNode as _createElementVNode, withDirectives as _withDirectives, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-18f65491"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "ant-row" }
const _hoisted_2 = { class: "ant-col ant-col-xs-24 ant-col-xl-24" }
const _hoisted_3 = ["disabled"]
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Avançar", -1))
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = { class: "ant-row" }
const _hoisted_7 = { class: "ant-col ant-col-xs-24 ant-col-xl-6 ss-display-flex" }
const _hoisted_8 = { class: "ss-empresa-texto" }
const _hoisted_9 = {
  class: "ss-empresa-texto",
  style: {"font-size":"18px"}
}
const _hoisted_10 = { class: "ant-col ant-col-xs-24 ant-col-xl-18 ss-display-flex" }
const _hoisted_11 = {
  key: 0,
  class: "ss-empresa-texto"
}
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Razão Social:", -1))
const _hoisted_13 = { class: "ss-empresa-texto" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Confirmar e adicionar minha empresa neste Grupo", -1))
const _hoisted_15 = [
  _hoisted_14
]
const _hoisted_16 = { class: "ant-row" }
const _hoisted_17 = { class: "ant-col ant-col-xs-24 ant-col-xl-2" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ant-col ant-col-xs-24 ant-col-xl-6" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Perfis de Usuários")
], -1))
const _hoisted_19 = { class: "ant-col ant-col-xs-24 ant-col-xl-2" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ant-col ant-col-xs-24 ant-col-xl-6" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Usuários")
], -1))
const _hoisted_21 = { class: "ant-row" }
const _hoisted_22 = { class: "ant-col ant-col-xs-24 ant-col-xl-2" }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ant-col ant-col-xs-24 ant-col-xl-6" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Colaboradores")
], -1))
const _hoisted_24 = { class: "ant-col ant-col-xs-24 ant-col-xl-2" }
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ant-col ant-col-xs-24 ant-col-xl-6" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Clientes")
], -1))
const _hoisted_26 = { class: "ant-col ant-col-xs-24 ant-col-xl-2" }
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ant-col ant-col-xs-24 ant-col-xl-6" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Fornecedores")
], -1))
const _hoisted_28 = { class: "ant-row" }
const _hoisted_29 = { class: "ant-col ant-col-xs-24 ant-col-xl-2" }
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ant-col ant-col-xs-24 ant-col-xl-6" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Transportadoras")
], -1))
const _hoisted_31 = { class: "ant-col ant-col-xs-24 ant-col-xl-2" }
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ant-col ant-col-xs-24 ant-col-xl-6" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Representantes")
], -1))
const _hoisted_33 = { class: "ant-row" }
const _hoisted_34 = { class: "ant-col ant-col-xs-24 ant-col-xl-2" }
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ant-col ant-col-xs-24 ant-col-xl-6" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Tipos de Contatos")
], -1))
const _hoisted_36 = { class: "ant-col ant-col-xs-24 ant-col-xl-2" }
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ant-col ant-col-xs-24 ant-col-xl-6" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Funções dos Colaboradores")
], -1))
const _hoisted_38 = { class: "ant-col ant-col-xs-24 ant-col-xl-2" }
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ant-col ant-col-xs-24 ant-col-xl-6" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Departamentos dos Colaboradores")
], -1))
const _hoisted_40 = { class: "ant-row" }
const _hoisted_41 = { class: "ant-col ant-col-xs-24 ant-col-xl-2" }
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ant-col ant-col-xs-24 ant-col-xl-6" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Produtos")
], -1))
const _hoisted_43 = { class: "ant-col ant-col-xs-24 ant-col-xl-2" }
const _hoisted_44 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ant-col ant-col-xs-24 ant-col-xl-6" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Marcas")
], -1))
const _hoisted_45 = { class: "ant-col ant-col-xs-24 ant-col-xl-2" }
const _hoisted_46 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ant-col ant-col-xs-24 ant-col-xl-6" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Categorias")
], -1))
const _hoisted_47 = { class: "ant-row" }
const _hoisted_48 = { class: "ant-col ant-col-xs-24 ant-col-xl-2" }
const _hoisted_49 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ant-col ant-col-xs-24 ant-col-xl-6" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Unidades")
], -1))
const _hoisted_50 = { class: "ant-col ant-col-xs-24 ant-col-xl-2" }
const _hoisted_51 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ant-col ant-col-xs-24 ant-col-xl-6" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Características")
], -1))
const _hoisted_52 = { class: "ant-col ant-col-xs-24 ant-col-xl-2" }
const _hoisted_53 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ant-col ant-col-xs-24 ant-col-xl-6" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Estoques")
], -1))
const _hoisted_54 = { class: "ant-row" }
const _hoisted_55 = { class: "ant-col ant-col-xs-24 ant-col-xl-2" }
const _hoisted_56 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ant-col ant-col-xs-24 ant-col-xl-6" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Serviços")
], -1))
const _hoisted_57 = { class: "ant-row" }
const _hoisted_58 = { class: "ant-col ant-col-xs-24 ant-col-xl-2" }
const _hoisted_59 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ant-col ant-col-xs-24 ant-col-xl-6" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Tipos de Custo")
], -1))
const _hoisted_60 = { class: "ant-col ant-col-xs-24 ant-col-xl-2" }
const _hoisted_61 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ant-col ant-col-xs-24 ant-col-xl-6" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Tipos de Preços")
], -1))
const _hoisted_62 = { class: "ant-col ant-col-xs-24 ant-col-xl-2" }
const _hoisted_63 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ant-col ant-col-xs-24 ant-col-xl-6" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Tabelas de Preços")
], -1))
const _hoisted_64 = { class: "ant-row" }
const _hoisted_65 = { class: "ant-col ant-col-xs-24 ant-col-xl-2" }
const _hoisted_66 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ant-col ant-col-xs-24 ant-col-xl-6" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Planos de Contas")
], -1))
const _hoisted_67 = { class: "ant-col ant-col-xs-24 ant-col-xl-2" }
const _hoisted_68 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ant-col ant-col-xs-24 ant-col-xl-6" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Centros de Custos")
], -1))
const _hoisted_69 = { class: "ant-col ant-col-xs-24 ant-col-xl-2" }
const _hoisted_70 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ant-col ant-col-xs-24 ant-col-xl-6" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Tipos de Documentos")
], -1))
const _hoisted_71 = { class: "ant-row" }
const _hoisted_72 = { class: "ant-col ant-col-xs-24 ant-col-xl-2" }
const _hoisted_73 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ant-col ant-col-xs-24 ant-col-xl-6" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Contas Contábeis Referenciadas")
], -1))
const _hoisted_74 = { class: "ant-col ant-col-xs-24 ant-col-xl-2" }
const _hoisted_75 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ant-col ant-col-xs-24 ant-col-xl-6" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Processos de Vendas")
], -1))
const _hoisted_76 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Concluir", -1))
const _hoisted_77 = [
  _hoisted_76
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_icone = _resolveComponent("icone")!
  const _component_card = _resolveComponent("card")!
  const _component_a_switch = _resolveComponent("a-switch")!
  const _component_a_divider = _resolveComponent("a-divider")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_requisicao_modal = _resolveComponent("requisicao-modal")!
  const _component_a_modal = _resolveComponent("a-modal")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_a_modal, {
      width: "900px",
      centered: "",
      visible: _ctx.modalBase.computedVisivel,
      "onUpdate:visible": _cache[30] || (_cache[30] = ($event: any) => ((_ctx.modalBase.computedVisivel) = $event)),
      title: _ctx.obtemTituloModalAdicionarEmpresa(),
      footer: null
    }, {
      closeIcon: _withCtx(() => [
        _createVNode(_component_icone, { nome: "voltar" })
      ]),
      default: _withCtx(() => [
        _createVNode(_component_a_form, { layout: "vertical" }, {
          default: _withCtx(() => [
            ((_ctx.state.etapaAdcionarEmpresaGrupo === 1))
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _createElementVNode("div", _hoisted_1, [
                    _createElementVNode("div", _hoisted_2, [
                      _withDirectives(_createElementVNode("textarea", {
                        class: "ant-input",
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.state.tokenGrupoEmpresa) = $event)),
                        placeholder: "Cole o seu Token aqui",
                        rows: "1"
                      }, null, 512), [
                        [_vModelText, _ctx.state.tokenGrupoEmpresa]
                      ])
                    ])
                  ]),
                  _createElementVNode("button", {
                    onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.obterGrupoEmpresaPorToken && _ctx.obterGrupoEmpresaPorToken(...args))),
                    disabled: !_ctx.UtilitarioGeral.valorValido(_ctx.state.tokenGrupoEmpresa),
                    type: "button",
                    class: "ant-btn ant-btn-block ant-btn-primary ss-empresa-mt-15"
                  }, _hoisted_5, 8, _hoisted_3)
                ], 64))
              : ((_ctx.state.etapaAdcionarEmpresaGrupo === 2))
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.state.grupoEmpresaToken.empresas, (empresa) => {
                      return (_openBlock(), _createBlock(_component_card, {
                        key: 'EMP-GRP' + empresa.codigo
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_6, [
                            _createElementVNode("div", _hoisted_7, [
                              _createElementVNode("div", null, [
                                _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.UtilitarioGeral.documentoIdentificacaoCPFouCNPJ(empresa.cpfCnpj)), 1),
                                _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.UtilitarioMascara.mascararCPFOuCNPJ(empresa.cpfCnpj)), 1)
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_10, [
                              _createElementVNode("div", null, [
                                (empresa.cpfCnpj.length === 14)
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_11, [
                                      _hoisted_12,
                                      _createTextVNode(" " + _toDisplayString(empresa.nomeRazaoSocial), 1)
                                    ]))
                                  : _createCommentVNode("", true),
                                _createElementVNode("span", _hoisted_13, [
                                  _createElementVNode("b", null, _toDisplayString(empresa.cpfCnpj.length === 14 ? 'Nome fantasia:' : 'Nome completo'), 1),
                                  _createTextVNode(" " + _toDisplayString(empresa.nomeFantasia), 1)
                                ])
                              ])
                            ])
                          ])
                        ]),
                        _: 2
                      }, 1024))
                    }), 128)),
                    _createElementVNode("button", {
                      onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.obterInformacoesCadastroCompartilhado())),
                      type: "button",
                      class: "ant-btn ant-btn-block ant-btn-primary ss-empresa-mt-15"
                    }, _hoisted_15)
                  ], 64))
                : ((_ctx.state.etapaAdcionarEmpresaGrupo === 3))
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                      _createVNode(_component_card, { titulo: "Sistema" }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_16, [
                            _createElementVNode("div", _hoisted_17, [
                              _createVNode(_component_a_switch, {
                                checked: _ctx.obtemValor('CADASTRO_PERFIS_USUARIOS'),
                                "checked-children": "Sim",
                                "un-checked-children": "Não",
                                onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.defineValor('CADASTRO_PERFIS_USUARIOS'))),
                                disabled: true
                              }, null, 8, ["checked"])
                            ]),
                            _hoisted_18,
                            _createElementVNode("div", _hoisted_19, [
                              _createVNode(_component_a_switch, {
                                checked: _ctx.obtemValor('CADASTRO_USUARIOS'),
                                "checked-children": "Sim",
                                "un-checked-children": "Não",
                                onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.defineValor('CADASTRO_USUARIOS'))),
                                disabled: true
                              }, null, 8, ["checked"])
                            ]),
                            _hoisted_20
                          ])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_card, { titulo: "Pessoas" }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_21, [
                            _createElementVNode("div", _hoisted_22, [
                              _createVNode(_component_a_switch, {
                                checked: _ctx.obtemValor('CADASTRO_COLABORADORES'),
                                "checked-children": "Sim",
                                "un-checked-children": "Não",
                                onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.defineValor('CADASTRO_COLABORADORES')))
                              }, null, 8, ["checked"])
                            ]),
                            _hoisted_23,
                            _createElementVNode("div", _hoisted_24, [
                              _createVNode(_component_a_switch, {
                                checked: _ctx.obtemValor('CADASTRO_CLIENTES'),
                                "checked-children": "Sim",
                                "un-checked-children": "Não",
                                onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.defineValor('CADASTRO_CLIENTES')))
                              }, null, 8, ["checked"])
                            ]),
                            _hoisted_25,
                            _createElementVNode("div", _hoisted_26, [
                              _createVNode(_component_a_switch, {
                                checked: _ctx.obtemValor('CADASTRO_FORNECEDORES'),
                                "checked-children": "Sim",
                                "un-checked-children": "Não",
                                onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.defineValor('CADASTRO_FORNECEDORES')))
                              }, null, 8, ["checked"])
                            ]),
                            _hoisted_27
                          ]),
                          _createElementVNode("div", _hoisted_28, [
                            _createElementVNode("div", _hoisted_29, [
                              _createVNode(_component_a_switch, {
                                checked: _ctx.obtemValor('CADASTRO_TRANSPORTADORAS'),
                                "checked-children": "Sim",
                                "un-checked-children": "Não",
                                onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.defineValor('CADASTRO_TRANSPORTADORAS')))
                              }, null, 8, ["checked"])
                            ]),
                            _hoisted_30,
                            _createElementVNode("div", _hoisted_31, [
                              _createVNode(_component_a_switch, {
                                checked: _ctx.obtemValor('CADASTRO_REPRESENTANTES'),
                                "checked-children": "Sim",
                                "un-checked-children": "Não",
                                onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.defineValor('CADASTRO_REPRESENTANTES')))
                              }, null, 8, ["checked"])
                            ]),
                            _hoisted_32
                          ]),
                          _createVNode(_component_a_divider, null, {
                            default: _withCtx(() => [
                              _createTextVNode("Cadastros relacionados a pessoas")
                            ]),
                            _: 1
                          }),
                          _createElementVNode("div", _hoisted_33, [
                            _createElementVNode("div", _hoisted_34, [
                              _createVNode(_component_a_switch, {
                                checked: _ctx.obtemValor('CADASTRO_TIPOS_CONTATOS'),
                                "checked-children": "Sim",
                                "un-checked-children": "Não",
                                onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.defineValor('CADASTRO_TIPOS_CONTATOS')))
                              }, null, 8, ["checked"])
                            ]),
                            _hoisted_35,
                            _createElementVNode("div", _hoisted_36, [
                              _createVNode(_component_a_switch, {
                                checked: _ctx.obtemValor('CADASTRO_FUNCOES_COLABORADORES'),
                                "checked-children": "Sim",
                                "un-checked-children": "Não",
                                onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.defineValor('CADASTRO_FUNCOES_COLABORADORES'))),
                                disabled: _ctx.state.bloquearRelacionadosColaborador
                              }, null, 8, ["checked", "disabled"])
                            ]),
                            _hoisted_37,
                            _createElementVNode("div", _hoisted_38, [
                              _createVNode(_component_a_switch, {
                                checked: _ctx.obtemValor('CADASTRO_DEPARTAMENTOS_COLABORADORES'),
                                "checked-children": "Sim",
                                "un-checked-children": "Não",
                                onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.defineValor('CADASTRO_DEPARTAMENTOS_COLABORADORES'))),
                                disabled: _ctx.state.bloquearRelacionadosColaborador
                              }, null, 8, ["checked", "disabled"])
                            ]),
                            _hoisted_39
                          ])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_card, { titulo: "Produtos e Serviços" }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_40, [
                            _createElementVNode("div", _hoisted_41, [
                              _createVNode(_component_a_switch, {
                                checked: _ctx.obtemValor('CADASTRO_PRODUTOS'),
                                "checked-children": "Sim",
                                "un-checked-children": "Não",
                                onClick: _cache[13] || (_cache[13] = ($event: any) => (_ctx.defineValor('CADASTRO_PRODUTOS')))
                              }, null, 8, ["checked"])
                            ]),
                            _hoisted_42,
                            _createElementVNode("div", _hoisted_43, [
                              _createVNode(_component_a_switch, {
                                checked: _ctx.obtemValor('CADASTRO_MARCAS'),
                                "checked-children": "Sim",
                                "un-checked-children": "Não",
                                onClick: _cache[14] || (_cache[14] = ($event: any) => (_ctx.defineValor('CADASTRO_MARCAS'))),
                                disabled: _ctx.state.bloquearRelacionadosProduto
                              }, null, 8, ["checked", "disabled"])
                            ]),
                            _hoisted_44,
                            _createElementVNode("div", _hoisted_45, [
                              _createVNode(_component_a_switch, {
                                checked: _ctx.obtemValor('CADASTRO_CATEGORIAS_PRODUTOS'),
                                "checked-children": "Sim",
                                "un-checked-children": "Não",
                                onClick: _cache[15] || (_cache[15] = ($event: any) => (_ctx.defineValor('CADASTRO_CATEGORIAS_PRODUTOS'))),
                                disabled: _ctx.state.bloquearRelacionadosProduto
                              }, null, 8, ["checked", "disabled"])
                            ]),
                            _hoisted_46
                          ]),
                          _createElementVNode("div", _hoisted_47, [
                            _createElementVNode("div", _hoisted_48, [
                              _createVNode(_component_a_switch, {
                                checked: _ctx.obtemValor('CADASTRO_UNIDADES'),
                                "checked-children": "Sim",
                                "un-checked-children": "Não",
                                onClick: _cache[16] || (_cache[16] = ($event: any) => (_ctx.defineValor('CADASTRO_UNIDADES'))),
                                disabled: _ctx.state.bloquearRelacionadosProduto
                              }, null, 8, ["checked", "disabled"])
                            ]),
                            _hoisted_49,
                            _createElementVNode("div", _hoisted_50, [
                              _createVNode(_component_a_switch, {
                                checked: _ctx.obtemValor('CADASTRO_CARACTERISTICAS'),
                                "checked-children": "Sim",
                                "un-checked-children": "Não",
                                onClick: _cache[17] || (_cache[17] = ($event: any) => (_ctx.defineValor('CADASTRO_CARACTERISTICAS'))),
                                disabled: _ctx.state.bloquearRelacionadosProduto
                              }, null, 8, ["checked", "disabled"])
                            ]),
                            _hoisted_51,
                            _createElementVNode("div", _hoisted_52, [
                              _createVNode(_component_a_switch, {
                                checked: _ctx.obtemValor('CADASTRO_ESTOQUES'),
                                "checked-children": "Sim",
                                "un-checked-children": "Não",
                                onClick: _cache[18] || (_cache[18] = ($event: any) => (_ctx.defineValor('CADASTRO_ESTOQUES'))),
                                disabled: _ctx.state.bloquearRelacionadosProduto
                              }, null, 8, ["checked", "disabled"])
                            ]),
                            _hoisted_53
                          ]),
                          _createElementVNode("div", _hoisted_54, [
                            _createElementVNode("div", _hoisted_55, [
                              _createVNode(_component_a_switch, {
                                checked: _ctx.obtemValor('CADASTRO_SERVICOS'),
                                "checked-children": "Sim",
                                "un-checked-children": "Não",
                                onClick: _cache[19] || (_cache[19] = ($event: any) => (_ctx.defineValor('CADASTRO_SERVICOS')))
                              }, null, 8, ["checked"])
                            ]),
                            _hoisted_56
                          ]),
                          _createVNode(_component_a_divider, null, {
                            default: _withCtx(() => [
                              _createTextVNode("Precificação")
                            ]),
                            _: 1
                          }),
                          _createElementVNode("div", _hoisted_57, [
                            _createElementVNode("div", _hoisted_58, [
                              _createVNode(_component_a_switch, {
                                checked: _ctx.obtemValor('CADASTRO_TIPOS_CUSTO'),
                                "checked-children": "Sim",
                                "un-checked-children": "Não",
                                onClick: _cache[20] || (_cache[20] = ($event: any) => (_ctx.defineValor('CADASTRO_TIPOS_CUSTO'))),
                                disabled: _ctx.state.bloquearRelacionadosProduto
                              }, null, 8, ["checked", "disabled"])
                            ]),
                            _hoisted_59,
                            _createElementVNode("div", _hoisted_60, [
                              _createVNode(_component_a_switch, {
                                checked: _ctx.obtemValor('CADASTRO_TIPOS_PRECO'),
                                "checked-children": "Sim",
                                "un-checked-children": "Não",
                                onClick: _cache[21] || (_cache[21] = ($event: any) => (_ctx.defineValor('CADASTRO_TIPOS_PRECO'))),
                                disabled: _ctx.state.bloquearRelacionadosProduto
                              }, null, 8, ["checked", "disabled"])
                            ]),
                            _hoisted_61,
                            _createElementVNode("div", _hoisted_62, [
                              _createVNode(_component_a_switch, {
                                checked: _ctx.obtemValor('CADASTRO_TABELAS_PRECOS'),
                                "checked-children": "Sim",
                                "un-checked-children": "Não",
                                onClick: _cache[22] || (_cache[22] = ($event: any) => (_ctx.defineValor('CADASTRO_TABELAS_PRECOS'))),
                                disabled: _ctx.state.bloquearRelacionadosProduto
                              }, null, 8, ["checked", "disabled"])
                            ]),
                            _hoisted_63
                          ])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_card, { titulo: "Financeiro e Vendas" }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_64, [
                            _createElementVNode("div", _hoisted_65, [
                              _createVNode(_component_a_switch, {
                                checked: _ctx.obtemValor('CADASTRO_PLANOS_CONTAS'),
                                "checked-children": "Sim",
                                "un-checked-children": "Não",
                                onClick: _cache[23] || (_cache[23] = ($event: any) => (_ctx.defineValor('CADASTRO_PLANOS_CONTAS')))
                              }, null, 8, ["checked"])
                            ]),
                            _hoisted_66,
                            _createElementVNode("div", _hoisted_67, [
                              _createVNode(_component_a_switch, {
                                checked: _ctx.obtemValor('CADASTRO_CENTROS_CUSTOS'),
                                "checked-children": "Sim",
                                "un-checked-children": "Não",
                                onClick: _cache[24] || (_cache[24] = ($event: any) => (_ctx.defineValor('CADASTRO_CENTROS_CUSTOS')))
                              }, null, 8, ["checked"])
                            ]),
                            _hoisted_68,
                            _createElementVNode("div", _hoisted_69, [
                              _createVNode(_component_a_switch, {
                                checked: _ctx.obtemValor('CADASTRO_TIPOS_DOCUMENTO_FINANCEIRO'),
                                "checked-children": "Sim",
                                "un-checked-children": "Não",
                                onClick: _cache[25] || (_cache[25] = ($event: any) => (_ctx.defineValor('CADASTRO_TIPOS_DOCUMENTO_FINANCEIRO')))
                              }, null, 8, ["checked"])
                            ]),
                            _hoisted_70
                          ]),
                          _createElementVNode("div", _hoisted_71, [
                            _createElementVNode("div", _hoisted_72, [
                              _createVNode(_component_a_switch, {
                                checked: _ctx.obtemValor('CADASTRO_CONTAS_CONTABEIS_REFERENCIADAS'),
                                "checked-children": "Sim",
                                "un-checked-children": "Não",
                                onClick: _cache[26] || (_cache[26] = ($event: any) => (_ctx.defineValor('CADASTRO_CONTAS_CONTABEIS_REFERENCIADAS')))
                              }, null, 8, ["checked"])
                            ]),
                            _hoisted_73,
                            _createElementVNode("div", _hoisted_74, [
                              _createVNode(_component_a_switch, {
                                checked: _ctx.obtemValor('CADASTRO_PROCESSOS_VENDAS'),
                                "checked-children": "Sim",
                                "un-checked-children": "Não",
                                onClick: _cache[27] || (_cache[27] = ($event: any) => (_ctx.defineValor('CADASTRO_PROCESSOS_VENDAS')))
                              }, null, 8, ["checked"])
                            ]),
                            _hoisted_75
                          ])
                        ]),
                        _: 1
                      }),
                      _createElementVNode("button", {
                        onClick: _cache[28] || (_cache[28] = ($event: any) => (_ctx.concluirAdicionarEmpresaGrupo())),
                        type: "button",
                        class: "ant-btn ant-btn-block ant-btn-primary ss-empresa-mt-15"
                      }, _hoisted_77)
                    ], 64))
                  : _createCommentVNode("", true)
          ]),
          _: 1
        }),
        _createVNode(_component_requisicao_modal, {
          visivel: _ctx.modalBase.exibirRequisicaoModal,
          "onUpdate:visivel": _cache[29] || (_cache[29] = ($event: any) => ((_ctx.modalBase.exibirRequisicaoModal) = $event)),
          apresentarBarraProgresso: _ctx.modalBase.apresentarBarraProgresso,
          fraseBarraProgresso: _ctx.modalBase.fraseBarraProgresso,
          retornoRequisicao: _ctx.modalBase.retornoRequisicao
        }, null, 8, ["visivel", "apresentarBarraProgresso", "fraseBarraProgresso", "retornoRequisicao"])
      ]),
      _: 1
    }, 8, ["visible", "title"])
  ]))
}